import {ActionTree, GetterTree, Module, MutationTree} from 'vuex';
import {RootState} from '../RootState';
import axios from "axios";
import {settings} from "@/plugins/settings";
import {IErrors} from "@/model/IErrors";
import responseHandler from "@/plugins/errorHandling";

export interface IPermissionMap {
  id: number;
  action: string;
  permission: number;
  code: number;
  created_at: string;
}

interface PermissionsState {
  permissionMaps: IPermissionMap[];
  actionTargets: any;
  permissionTargets: any;
  errors: IErrors;
}

const state: PermissionsState = {
  permissionMaps: [],
  actionTargets: {},
  permissionTargets: {},
  errors: {},
};

const getters: GetterTree<PermissionsState, RootState> = {
  permissionMaps: (state): IPermissionMap[] => state.permissionMaps,
  actionTargets: (state): any => state.actionTargets,
  permissionTargets: (state): any => state.permissionTargets,
  errors: (state) => state.errors,
};

const actions: ActionTree<PermissionsState, RootState> = {
  fetchPermissionMaps: ({ commit }): any => responseHandler.handle(
    () => axios({
      url: settings.endpoint + 'permissions/maps',
    }),
    commit,
    'permissionMapsLoaded'
  ),
  fetchActionTargets: ({ commit }): any => responseHandler.handle(
    () => axios({
      url: settings.endpoint + 'permissions/actionTargets',
    }),
    commit,
    'actionTargetsLoaded'
  ),
  fetchPermissionTargets: ({ commit, state }): any => responseHandler.debounce(
    state.permissionTargets,
    150,
    () => axios({
      url: settings.endpoint + 'permissions/permissionTargets',
    }),
    commit,
    'permissionTargetsLoaded',
    undefined, // null,
    true
    // NOTE this mutation is silenced so it won't make a KO
  ),
  setMap: ({ commit }, {action, permission, code}): any => responseHandler.handle(
    () => axios({
      url: settings.endpoint + 'permissions/maps',
      method: 'POST',
      data: {action, permission, code}
    }),
    commit,
    'permissionMapsLoaded'
  ),
  errors: ({commit}, errors: IErrors): any => {
    commit('errors', errors);
  }
};

const mutations: MutationTree<PermissionsState> = {
  permissionMapsLoaded(state, payload) {
    state.permissionMaps = payload;
  },
  actionTargetsLoaded(state, payload) {
    state.actionTargets = payload;
  },
  permissionTargetsLoaded(state, payload) {
    state.permissionTargets = payload;
  },
  errors(state, payload: IErrors) {
    state.errors = payload;
  },
};

const namespaced: boolean = true;

export const permissionsModule: Module<PermissionsState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
